// Required stylesheets
import '../../node_modules/sal.js/dist/sal.css';

import '../common/stylesheets/external-crutch.less';
import '../common/stylesheets/modules/footer/footer.less';
import '../common/stylesheets/modules/header/index.less';
import '../common/stylesheets/shapes.less';

import '../global/elements/buttons.less';
import '../global/settings/index.less';
import '../global/vendor/tailwind/tailwind.less';

import '../maker/landing/base.less';
import '../maker/landing/compatibility.less';
import '../maker/landing/maker-landing.less';
import '../maker/landing/maker-unsupported.less';
import '../maker/landing/normalize.css';

// Required JavaScripts
import '../common/javascripts/shared/toggleExpand.js';
import '../maker/landing/maker-landing';

import '../react/common/Logger';

import AppLoader from '../react/AppLoader/AppLoader';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [],
  auxApps: {
    ...NavApps
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  }
});
